import r,{keyframes as e}from"styled-components";import{theme as o}from"../../../../theme.js";const i=e`
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
`,t=r.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-column-gap: ${o.spacing*2}px;
  align-items: center;
  cursor: pointer;
  position: relative;
  z-index: 2;
  &:hover {
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background-color: ${o.colors.gray[100]};
      animation: ${i} 0.2s ease-in-out forwards;
      z-index: -1;
      border-radius: ${o.radius}px;
    }
    .icon {
      background-color: white;
      border: 4px solid ${o.colors.gray[100]};
      border-radius: 10px;
      transition: all 0.1s ease-in-out;
    }
  }
`,n=r.div`
  width: 40px;
  height: 40px;
  background-color: ${o.colors.gray[100]};
  border-radius: ${o.radius}px;
  border: 4px solid ${o.colors.gray[100]};;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${o.colors.primary[500]};
    }
  }
`,a=r.span`
  font-size: 14px;
  color: ${o.colors.gray[900]};
`;export{t as Container,n as IconContainer,a as Title,i as hoverOn};
